// extracted by mini-css-extract-plugin
export default {"products":"dr-z","card":"er-z","oosMessaging":"fr-z"};